import "./ElementsStyles.scss";

import React, { memo, useEffect, useRef } from "react";
import { Range } from "slate";
import { useSelected, useSlate } from "slate-react";

import { useEditorPopupContext } from "../../../contexts/editorPopupsContext";
import type { SlateRenderElementProps } from "../slateTypes";

const LinkComponent: React.FC<SlateRenderElementProps> = memo(props => {
  const { attributes, children, element } = props;
  const { setCurrentTarget } = useEditorPopupContext();
  const target = useRef<HTMLSpanElement>(null);
  const editor = useSlate();
  const selected = useSelected();
  const clickHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (target.current) {
      setCurrentTarget({
        element: target?.current?.querySelector("a"),
        type: "readyLink",
      });
    }
  };

  useEffect(() => {
    return () => {
      setCurrentTarget(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (editor.selection && selected && Range.isCollapsed(editor.selection)) {
      setTimeout(() => {
        setCurrentTarget({
          element: target?.current?.querySelector("a"),
          type: "readyLink",
        });
      });
    } else {
      setCurrentTarget(null);
    }
  }, [selected, editor.selection, setCurrentTarget]);

  return (
    <span ref={target} className="editor-element__link">
      <a
        {...attributes}
        href={element.url}
        onClick={clickHandler}
        data-testid="link-element"
      >
        {children}
      </a>
    </span>
  );
});

export { LinkComponent };
